// @flow
import React from "react";
import SvgIconContainer from '../SvgIconContainer';

export default (
	{
		unit = 'em',
		...rest
	}: Object = {}) => (
	<SvgIconContainer viewBox="0 0 16 16" {...rest} unit={unit}>
		<g transform="translate(-1.000000, 0.000000)" fill="#FFFFFF">
			<path d="M1,4.57142857 L7.16611296,0 L7.16611296,2.23255814 C16.8936877,2.71096346
			16.8405316,15.5747508 7.11295681,16 L7.11295681,14.4584718 C14.2358804,14.0332226
			14.2358804,7.38870432 7.16611296,6.910299 L7.16611296,9.19601329 L1,4.57142857 Z" />
		</g>
	</SvgIconContainer>
);


// WEBPACK FOOTER //
// ./src/components/Icons/Revert.js